// Generated from src/img/svg/ic-db_navigation_expand-more_24.svg

export const IcDbNavigationExpandMore24 = (props) => {
  return (
    <svg height="24" viewBox="0 0 24 24" width="24" {...props}>
      <path
        d="M18 8c.563 0 1 .438 1 1 0 .25-.125.5-.312.688l-5.97 6.03A1.04 1.04 0 0 1 12 16c-.25 0-.531-.094-.719-.281L5.312 9.688C5.126 9.5 5 9.25 5 9c0-.562.438-1 1-1 .281 0 .5.094.719.281L12 13.562l5.281-5.28A1 1 0 0 1 18 8"
        fill="#282D37"
        fillRule="evenodd"
      />
    </svg>
  );
};
